var React = require('react');

function BlogFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.9994 1.33337H9.99935C9.1153 1.33337 8.26745 1.68456 7.64233 2.30968C7.01721 2.93481 6.66602 3.78265 6.66602 4.66671V6.66671H4.66602V9.33337H6.66602V14.6667H9.33268V9.33337H11.3327L11.9994 6.66671H9.33268V4.66671C9.33268 4.4899 9.40292 4.32033 9.52795 4.1953C9.65297 4.07028 9.82254 4.00004 9.99935 4.00004H11.9994V1.33337Z","fill":"white"}));
}

BlogFacebook.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = BlogFacebook;

BlogFacebook.default = BlogFacebook;
